import React from 'react'

export default function FaceFeature({ scaleX, fill }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M2.48999 4.98C3.86518 4.98 4.97998 3.86519 4.97998 2.49C4.97998 1.11481 3.86518 0 2.48999 0C1.1148 0 0 1.11481 0 2.49C0 3.86519 1.1148 4.98 2.48999 4.98Z"
        fill={fill} // "white"
      />
      <path
        d="M70.3499 4.98C71.725 4.98 72.8399 3.86519 72.8399 2.49C72.8399 1.11481 71.725 0 70.3499 0C68.9747 0 67.8599 1.11481 67.8599 2.49C67.8599 3.86519 68.9747 4.98 70.3499 4.98Z"
        fill={fill} // "white"
      />
    </g>
  )
}
